var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "M18.82 23.92 8.94 34.16a3.39 3.39 0 0 0 0 4.75H9a3.4 3.4 0 0 0 4.83 0l9.75-10M24.72 17.91 33.37 9l7-2.57a.52.52 0 0 1 .66.69l-3.17 7.52-8.25 8.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    d: "M12.79 6.14c2.61-.4 10.69-.74 10.69 10.5L40.3 33.79a4.33 4.33 0 0 1-4.704 7.046 4.3 4.3 0 0 1-1.506-1.016L17.35 22.39S7.12 24.94 7 12.22a.43.43 0 0 1 .71-.33l4.44 3.84 4.43-4.83-4-4a.43.43 0 0 1 .21-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7900",
    d: "m10.39 32.65 4.56 4.57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 5h36.53v37.15H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering);
export default __webpack_public_path__ + "static/media/engineering.5a9028b2710d8f6b054a36562e23b5f2.svg";
export { ForwardRef as ReactComponent };